import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPlane } from "react-icons/fa";
import Title from "../layouts/Title";
import Reveal from "../layouts/Reveal";
import { iconFor } from "../layouts/techIcons";
import { aboutText, profile, servicesData } from "../../constants";
import { avatar } from "../../assets/index";

const About = () => {
  return (
    <section id="about" className="sectionWrap">
      <Title title="About Me" des="Engineer Who Ships With Customers" />
      <div className="grid grid-cols-1 lgl:grid-cols-5 gap-10">
        <Reveal className="lgl:col-span-2">
          <div className="card p-8 h-full flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <span className="shrink-0 w-20 h-20 rounded-2xl p-[2px] bg-gradient-to-br from-designColor to-[#ff8a5c]">
                <img src={avatar} alt={profile.name} className="w-full h-full rounded-[14px] object-cover" />
              </span>
              <div>
                <h3 className="text-2xl font-bold text-white font-titleFont">{profile.name}</h3>
                <p className="text-designColor text-sm">{profile.role}</p>
              </div>
            </div>
            {aboutText.map((para) => (
              <p key={para.slice(0, 24)} className="text-gray-400 leading-7">
                {para}
              </p>
            ))}
            <div className="flex flex-col gap-3 mt-auto pt-2 text-sm text-gray-300">
              <span className="inline-flex items-center gap-3">
                <FaMapMarkerAlt className="text-designColor" /> {profile.location}
              </span>
              <span className="inline-flex items-center gap-3">
                <FaPlane className="text-designColor" /> {profile.relocation}
              </span>
              <a href={`mailto:${profile.email}`} className="inline-flex items-center gap-3 hover:text-designColor duration-300 break-all">
                <FaEnvelope className="text-designColor shrink-0" /> {profile.email}
              </a>
            </div>
          </div>
        </Reveal>
        <div className="lgl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
          {servicesData.map(({ icon, title, des }, index) => (
            <Reveal key={title} delay={index * 0.1}>
              <div className="card p-6 md:p-7 h-full flex flex-col gap-5 items-start group hover:border-designColor/40 hover:-translate-y-1 duration-300">
                <span className="shrink-0 w-14 h-14 rounded-2xl bg-designColor/10 text-designColor text-2xl inline-flex items-center justify-center group-hover:bg-designColor group-hover:text-white duration-300">
                  {iconFor(icon)}
                </span>
                <div>
                  <h4 className="text-xl font-semibold text-white font-titleFont">{title}</h4>
                  <p className="text-gray-400 mt-2 leading-7">{des}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
